export { FlashSalePill } from './FlashSalePill';
